'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-4474431a.js');
const search_store = require('./search.store-f44567ad.js');

const vviinnPreloaderCss = ":host{--preloader-size:24px;--preloader-width:calc(var(--preloader-size) / 6);transform-origin:center;animation:rotate 3s linear infinite;border:var(--preloader-width) solid currentColor;border-radius:50%;border-top-color:transparent;display:none;outline:0;width:var(--preloader-size);height:var(--preloader-size);box-sizing:border-box}:host(.active){display:flex}@keyframes rotate{from{transform:rotate(-360deg)}to{transform:rotate(360deg)}}";

const VviinnPreloader = class {
  constructor(hostRef) {
    index.registerInstance(this, hostRef);
  }
  isActive() {
    return search_store.searchState.loading || search_store.searchState.objectDetectionInProgress;
  }
  render() {
    return (index.h(index.Host, { class: {
        active: this.isActive(),
      } }));
  }
};
VviinnPreloader.style = vviinnPreloaderCss;

exports.vviinn_preloader = VviinnPreloader;
